/**
 * resource 模块中仅 EE 存在的菜单项（CE containers router 中没有）
 */
import store from '@/store'
import Layout from '@/layouts/RouterView'
import i18n from '@/locales'
import { featureMenuHiddenCheck } from '@/utils/auth'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'
import { isCE } from '@/utils/utils'

const Topology = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/topology')
const ModelArts = () => import(/* webpackChunkName: "ai" */ /* webpackPrefetch: true */ '@Ai-ee/views/modelarts')
const ModelArtsCreate = () => import(/* webpackChunkName: "ai" */ /* webpackPrefetch: true */ '@Ai-ee/views/modelarts/create')
const AiGateway = () => import(/* webpackChunkName: "ai" */ /* webpackPrefetch: true */ '@Ai-ee/views/ai-gateway')
const MCP = () => import(/* webpackChunkName: "ai" */ /* webpackPrefetch: true */ '@Ai-ee/views/mcp')
const MCPCreate = () => import(/* webpackChunkName: "ai" */ /* webpackPrefetch: true */ '@Ai-ee/views/mcp/create')
const CustomData = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/custom-data')
const ResourceTypeSetting = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/resource-type-setting')
const ResourceTypeSettingCreate = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/resource-type-setting/create')

export const topologySubmenu = {
  path: '/topology',
  meta: {
    label: i18n.t('system.global_topology'),
    hidden: (userInfo, menu) => {
      if (isScopedPolicyMenuHidden('sub_hidden_menus.topology')) {
        return true
      }
      return featureMenuHiddenCheck(menu)
    },
  },
  component: Layout,
  children: [
    {
      name: 'GlobalTopology',
      path: '',
      component: Topology,
      meta: {
        keepAlive: true,
        keepAliveViews: ['VMInstanceIndex', 'GPU'],
      },
    },
  ],
}

export const modelartsMenu = {
  meta: {
    label: i18n.t('common.platform'),
    hidden: () => store.getters.isSysCE,
  },
  group: 'resource',
  subGroup: 'ai',
  submenus: [
    {
      path: '/modelarts',
      permission: 'modelarts_list',
      meta: {
        label: 'ModelArts',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.modelarts')) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'ModelArts',
          path: '',
          component: ModelArts,
        },
        {
          name: 'ModelArtsCreate',
          path: 'create',
          component: ModelArtsCreate,
        },
      ],
    },
  ],
}

export const aiGatewaySubmenu = {
  path: '/ai-gateway',
  permission: 'ai_gateway_list',
  meta: {
    label: i18n.t('ai.ai_gateway'),
    hidden: (userInfo, menu) => {
      if (isScopedPolicyMenuHidden('sub_hidden_menus.ai_gateway')) {
        return true
      }
      if (isCE() || store.getters.isSysCE) {
        return true
      }
      return featureMenuHiddenCheck(menu)
    },
  },
  component: Layout,
  children: [
    {
      name: 'AiGateway',
      path: '',
      component: AiGateway,
    },
  ],
}

export const mcpMenu = {
  meta: {
    label: 'MCP',
    hidden: () => store.getters.isSysCE,
  },
  group: 'resource',
  subGroup: 'ai',
  submenus: [
    {
      path: '/mcp',
      meta: {
        label: i18n.t('ai.mcp.title'),
        permission: 'services_get',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.mcp')) {
            return true
          }
          if (!store.getters.isAdminMode) {
            return true
          }
          return false
        },
      },
      component: Layout,
      children: [
        {
          name: 'MCP',
          path: '',
          component: MCP,
        },
        {
          name: 'MCPCreate',
          path: 'create',
          component: MCPCreate,
        },
      ],
    },
  ],
}

export const customDataMenu = {
  meta: {
    label: i18n.t('dictionary.extdb'),
    t: 'dictionary.extdb',
  },
  group: 'resource',
  subGroup: 'resource',
  submenus: [
    {
      path: '/custom-data',
      meta: {
        label: i18n.t('dictionary.extdb'),
        t: 'dictionary.extdb',
        permission: 'ext_resources_list',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.custom_data')) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'CustomData',
          path: '',
          component: CustomData,
        },
      ],
    },
    {
      path: '/resource-type-setting',
      meta: {
        label: i18n.t('report.resource_type_settings'),
        permission: 'ext_resource_types_list',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.resource_type_setting')) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'ResourceTypeSetting',
          path: '',
          component: ResourceTypeSetting,
        },
        {
          name: 'ResourceTypeSettingCreate',
          path: 'create',
          component: ResourceTypeSettingCreate,
        },
      ],
    },
  ],
}
